<template>
  <div id='bd-forget'>
    <el-main>
        <el-row v-if="firstStep">
          <el-col :span="8"><div class="grid-content"></div></el-col>
          <el-col :span="6">
            <el-form :model="emailForm" status-icon :rules="forgetRoles" ref="emailForm" label-width="100px">
              <el-form-item label="邮箱" prop="email">
                <el-input type="email" placeholder="请输入邮箱" v-model="emailForm.email" clearable style="width: 300px;">
                  <el-button slot="append" :loading="emailButtonCountingDown" @click="getEmailCode">{{ emailButtonText }}</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="email_code">
                <el-input placeholder="请输入验证码" v-model="emailForm.email_code" auto-complete="off" clearable style="width: 300px;"></el-input>
              </el-form-item>
              <el-form-item>
                <!-- <el-button @click="routeLogin">登录</el-button> -->
                <el-button type="primary" @click="nextSecondStep">下一步</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="8"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row v-if="secondStep">
          <el-col :span="8"><div class="grid-content"></div></el-col>
          <el-col :span="6">
            <el-form :model="passwordForm" status-icon :rules="forgetRoles" ref="passwordForm" label-width="100px">
              <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="passwordForm.password" auto-complete="off" style="width: 300px;" clearable></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="rePassword">
                <el-input type="password" v-model="passwordForm.rePassword" auto-complete="off" style="width: 300px;" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="preSecondStep">上一步</el-button>
                <el-button type="primary" @click="changePassword">修改密码</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="8"><div class="grid-content"></div></el-col>
        </el-row>
    </el-main>
  </div>
</template>

<script>
// import { mapActions } from 'vuex'
import * as https from '@/apis/http'

export default {
  name: 'bd-forget',
  data () {
    var validateEmail = (rule, value, callback) => {
      // 验证邮箱唯一性
      https.emailForget(this.emailForm.email,
        response => {
          console.log(response)
          if (response.status_code === 200) {
            callback()
          } else {
            callback(new Error('邮箱不存在，请重新填写'))
          }
        }, error => {
          console.log(error)
        })
    }
    var validateEmailCode = (rule, value, callback) => {
      // 验证验证码的有效性
      if (parseInt(value) !== this.emailServerCode) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.passwordForm.rePassword !== '') {
          this.$refs.passwordForm.validateField('rePassword')
        }
        callback()
      }
    }
    var validateRePassword = (rule, value, callback) => {
      if (value !== this.passwordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      emailForm: {
        email: '',
        email_code: ''
      },
      passwordForm: {
        password: '',
        rePassword: ''
      },
      // 验证规则
      forgetRoles: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'change' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        email_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateEmailCode, trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 16, message: '长度在 6 到 16 个字符之间', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateRePassword, trigger: 'blur' }
        ]
      },
      // 邮箱验证码
      emailServerCode: 0,
      // 邮箱发送验证码button是否禁用
      emailButtonCountingDown: false,
      // 60秒倒计时
      emailCountDownTime: 0,
      // 验证邮箱
      firstStep: true,
      // 验证二级域名
      secondStep: false
    }
  },
  computed: {
    emailButtonText () {
      // 邮箱验证码button文字
      return this.emailCountDownTime > 0 ? this.emailCountDownTime + 's后重新获取' : '获取验证码'
    }
  },
  watch: {
    emailCountDownTime (value) {
      if (this.value === 0) {
        this.emailButtonCountingDown = false
      }
    }
  },
  methods: {
    // 获取验证码
    getEmailCode () {
      // 1. 首先验证输入框是否通过验证
      this.$refs['emailForm'].validateField('email', (error) => {
        console.log(error)
        if (!error) {
          // 2. 请求发送验证码
          https.getEmailCode(this.emailForm.email, response => {
            console.log(response)
            this.emailServerCode = response.data
            // 倒计时
            this.emailButtonCountingDown = true
            this.emailCountDownTime = 60
            this.emailTimer()
            // 提示
            this.$message({ message: '发送成功', type: 'success' })
          }, error => {
            console.log(error)
            this.$message.error('发送失败, 请重试' + error)
          })
        } else {
          return false
        }
      })
    },
    emailTimer () {
      // 倒计时
      if (this.emailCountDownTime > 0) {
        this.emailCountDownTime--
        setTimeout(this.emailTimer, 1000)
      }
    },
    nextSecondStep () {
      // 输入验证码，验证通过，这跳转到填写二级域名页面
      this.$refs['emailForm'].validate((valid) => {
        if (valid) {
          this.firstStep = false
          this.secondStep = true
        } else {
          return false
        }
      })
    },
    preSecondStep () {
      this.firstStep = true
      this.secondStep = false
    },
    changePassword () {
      https.changePassword(this.emailForm.email, this.passwordForm.password,
        response => {
          console.log(response)
          if (response.status_code === 200) {
            this.$message({ message: '修改成功, 请登录', type: 'success' })
            this.routeLogin()
          }
        }, error => {
          console.log(error)
        })
    },
    routeLogin () {
      // 跳转登录页面
      this.$router.replace('/login')
    }
  }

}
</script>

<style scoped>
#bd-forget {
  margin-top: 150px;
}
.grid-content {
  min-height: 36px;
}
</style>
